export default "/lg.ttf"